import { isAxiosError } from "axios";
import { useEffect, useState } from "react";

import {
  getConfiguration,
  registerConfiguration,
  deleteConfiguration,
  updateConfiguration,
} from "./service";

export default useMcubeEngageConfiguration;

function useMcubeEngageConfiguration(workspaceId) {
  const [mcubeEngageConfiguration, setMcubeEngageConfiguration] =
    useState(null);
  const [isConfigured, setIsConfigured] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const fetchMcubeEngageConfiguration = async (loading = true) => {
    const init = () => {
      setIsLoading(loading);
    };

    const success = (data) => {
      setMcubeEngageConfiguration(data);
      setIsConfigured(true);
      setIsLoading(false);
    };

    const error = () => {
      setMcubeEngageConfiguration({});
      setIsConfigured(false);
      setIsLoading(false);
    };

    init();

    try {
      const request = { params: { workspaceId } };
      const response = await getConfiguration(request);
      success(response.data);
    } catch (e) {
      if (isAxiosError(e) && e.response.status === 404) {
        error();
      }
    }
  };

  const registerMcubeEngageConfiguration = async (payload, lifecycleCbs) => {
    lifecycleCbs.init();

    try {
      const request = { params: { workspaceId }, body: payload };
      const response = await registerConfiguration(request);

      lifecycleCbs.success();
      fetchMcubeEngageConfiguration();
    } catch (e) {
      lifecycleCbs.error(e);
    }
  };

  const updateMcubeEngageConfiguration = async (payload, lifecycleCbs) => {
    lifecycleCbs.init();

    try {
      const request = { params: { workspaceId }, body: payload };
      const response = await updateConfiguration(request);

      lifecycleCbs.success();
      fetchMcubeEngageConfiguration();
    } catch (e) {
      lifecycleCbs.error(e);
    }
  };

  const deleteMCubeEngageConfiguration = async (lifecycleCbs) => {
    lifecycleCbs.init();
    try {
      const request = { params: { workspaceId } };
      const response = await deleteConfiguration(request);

      lifecycleCbs.success();
      fetchMcubeEngageConfiguration();
    } catch (e) {
      lifecycleCbs.error(e);
    }
  };

  useEffect(() => {
    if (workspaceId) fetchMcubeEngageConfiguration();
  }, [workspaceId]);

  return {
    isLoading,
    isConfigured,
    mcubeEngageConfiguration,
    fetchMcubeEngageConfiguration,
    registerMcubeEngageConfiguration,
    updateMcubeEngageConfiguration,
    deleteMCubeEngageConfiguration,
  };
}
